var map = {
	"./de/general3/slide1.svg": 65288,
	"./en/general3/slide1.svg": 120068,
	"./es/general3/slide1.svg": 496757,
	"./fr/general3/slide1.svg": 151661,
	"./nl/general3/slide1.svg": 497931,
	"./pt/general3/slide1.svg": 6921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 838798;